"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingUtil = void 0;
var lodash_1 = __importDefault(require("lodash"));
/*
    This utility performs matching tests against strings and objects. It centralizes the process of creating
    an escaped regular expression from a provided string and exposes a handful of test-matching functions that
    can be run against a single string or an object.

    Object matching has an optional property in which a list of strings can be used to narrow down which properties
    to match on the object.
*/
exports.MatchingUtil = {
    getRegExp: function (searchText, global, ignoreCase, escape) {
        searchText = searchText || '';
        escape = escape || false;
        var flags = "".concat(ignoreCase ? 'i' : '').concat(global ? 'g' : '');
        if (!escape) {
            return new RegExp(searchText, flags);
        }
        return new RegExp('(' + lodash_1.default.escapeRegExp(searchText) + ')', flags);
    },
    // obtain which properties to match on, either implicitly from the object itself
    // or a verification of the provided list against the object
    getObjectProperties: function (value, properties) {
        if (properties === undefined) {
            return lodash_1.default.keys(value);
        }
        var keys = lodash_1.default.keys(value);
        return lodash_1.default.filter(keys, function (x) { return properties.indexOf(x) > -1; });
    },
    // these functions automatically escape search text plus search globally and ignore case sensitivity
    testStringMatch: function (value, searchText) {
        if (searchText === undefined || !searchText) {
            return false;
        }
        return this.getRegExp(searchText, true, true, true).test(value);
    },
    testObjectMatch: function (value, searchText, properties) {
        var _this = this;
        if (searchText === undefined || !searchText) {
            return false;
        }
        return this.getObjectProperties(value, properties).some(function (prop) { return _this.testStringMatch(value[prop].toString(), searchText); });
    },
};
